// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/deep/ .mat-toolbar-multiple-rows {
   min-height: 34px !important;;
}

.mat-toolbar-row, .mat-toolbar-single-row {
   height: 34px;
}
/*/deep/ .mat-tab-body-wrapper{*/
   /*margin-left: -5px !important;*/
/*}*/

.button-right {
   width: 25px;
   height: 25px;
   right: 8px;
}

/deep/ .mat-tab-body.mat-tab-body-active {
   overflow-y: hidden;
}

.btn_add{

   color: #9b9696;
   font-size: 20px;
}

.button-right {
   width: 25px;
   height: 25px;
   right: 8px;
   margin-bottom: 17px;
   margin-left: 135px;
}

.font-attach-file {
   font-size: 14px !important;
}
.btn-right{
   margin-right: -8px;
   color: #9B9696;
}

.btn-delete {
   font-size: 20px;
}

.file-upload {
   display: none;
   overflow: hidden;
   width: 0;
   height: 0;
}

.active {
   background-color: rgba(0, 178, 201, .05);
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/attach-file/attach-file.component.css"],"names":[],"mappings":"AAAA;GACG,2BAA2B;AAC9B;;AAEA;GACG,YAAY;AACf;AACA,gCAAgC;GAC7B,gCAAgC;AACnC,IAAI;;AAEJ;GACG,WAAW;GACX,YAAY;GACZ,UAAU;AACb;;AAEA;GACG,kBAAkB;AACrB;;AAEA;;GAEG,cAAc;GACd,eAAe;AAClB;;AAEA;GACG,WAAW;GACX,YAAY;GACZ,UAAU;GACV,mBAAmB;GACnB,kBAAkB;AACrB;;AAEA;GACG,0BAA0B;AAC7B;AACA;GACG,kBAAkB;GAClB,cAAc;AACjB;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,aAAa;GACb,gBAAgB;GAChB,QAAQ;GACR,SAAS;AACZ;;AAEA;GACG,wCAAwC;AAC3C","sourcesContent":["/deep/ .mat-toolbar-multiple-rows {\n   min-height: 34px !important;;\n}\n\n.mat-toolbar-row, .mat-toolbar-single-row {\n   height: 34px;\n}\n/*/deep/ .mat-tab-body-wrapper{*/\n   /*margin-left: -5px !important;*/\n/*}*/\n\n.button-right {\n   width: 25px;\n   height: 25px;\n   right: 8px;\n}\n\n/deep/ .mat-tab-body.mat-tab-body-active {\n   overflow-y: hidden;\n}\n\n.btn_add{\n\n   color: #9b9696;\n   font-size: 20px;\n}\n\n.button-right {\n   width: 25px;\n   height: 25px;\n   right: 8px;\n   margin-bottom: 17px;\n   margin-left: 135px;\n}\n\n.font-attach-file {\n   font-size: 14px !important;\n}\n.btn-right{\n   margin-right: -8px;\n   color: #9B9696;\n}\n\n.btn-delete {\n   font-size: 20px;\n}\n\n.file-upload {\n   display: none;\n   overflow: hidden;\n   width: 0;\n   height: 0;\n}\n\n.active {\n   background-color: rgba(0, 178, 201, .05);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
